import CategoryUtils from '../utils/categories';
import Content from '../types/enums/content';
import Event from './event';
import IStreams from '../types/interfaces/streams';
import StreamUtils from '../utils/stream';
import StreamType from '../types/enums/stream';
import { ISeason } from '../types/interfaces/vod';
import {
  IFastEventRequest,
  IMediaProductionEventRequest,
} from '../types/interfaces/event';

class RegularEvent extends Event {
  duration: number;
  endBookmark: number;
  keepWatchingMark: number;
  season: ISeason;
  serie: string;
  showTitle?: boolean | null | undefined;
  start: number;
  startBookmark: number;
  streams?: IStreams;

  constructor(
    request: IFastEventRequest | IMediaProductionEventRequest,
    type: Content
  ) {
    super({ ...request, type });
    this.duration = request.duration || 0;
    this.endBookmark = request.endBookmark || 0;
    this.keepWatchingMark = parseInt(request.seguirViendoSeconds) || 0;
    this.season = {};
    this.serie = request?.serie || '';
    this.showTitle =
      type === Content.SHOW &&
      request.category &&
      !(request as IMediaProductionEventRequest)?.catchup
        ? CategoryUtils.checkIfShowTitle(request.category)
        : true;
    this.start = request.start || 0;
    this.startBookmark = request.startBookmark || 0;
    if (request.episodeTitle) {
      this.season.episodeTitle = request.episodeTitle;
    }
    if (request.url) {
      this.streams = {
        dash: StreamUtils.checkStreamType(request.url, StreamType.DASH),
        hls: StreamUtils.checkStreamType(request.url, StreamType.HLS),
      };
    }
  }

  getDuration() {
    return this.duration ? this.duration + ' min' : 0;
  }
}

export default RegularEvent;
